import type { VRM } from "@pixiv/three-vrm";
import * as THREE from "three";

export const BUNDLED_STUDENT_GLB = "/models/avatar-student.glb";
export const BUNDLED_STUDENT_FEMALE_GLB = "/models/avatar-student-female.glb";
export const BUNDLED_STUDENT_MALE_GLB = "/models/avatar-student-male.glb";
export const BUNDLED_COACH_GLB = "/models/avatar-coach.glb";

/** 모델 발바닥이 y=0, 전신 높이가 targetHeight 근처가 되도록 보정 */
export function applyFloorFit(root: THREE.Object3D, targetHeight = 1.65): void {
  root.updateMatrixWorld(true);
  const box = new THREE.Box3().setFromObject(root);
  if (box.isEmpty()) return;

  const size = box.getSize(new THREE.Vector3());
  const scale = targetHeight / Math.max(size.y, 0.01);
  root.scale.setScalar(scale);
  root.updateMatrixWorld(true);

  const fitted = new THREE.Box3().setFromObject(root);
  root.position.y -= fitted.min.y;
  root.updateMatrixWorld(true);
}

export function applyVrmFloorFit(vrm: VRM, targetHeight = 1.65): void {
  applyFloorFit(vrm.scene, targetHeight);
}

export function applyGlbFloorFit(root: THREE.Object3D, targetHeight = 1.65): void {
  applyFloorFit(root, targetHeight);
}

/** GLB 바이너리 매직 확인 (glTF) */
export function isGlbBuffer(buffer: ArrayBuffer): boolean {
  if (buffer.byteLength < 12) return false;
  const view = new DataView(buffer);
  return view.getUint32(0, true) === 0x46546c67;
}

/** 전신 GLB인지 간단 검증 (스킨 + 관절 수) */
export async function probeFullBodyGlb(url: string): Promise<boolean> {
  try {
    const res = await fetch(url, { method: "GET", headers: { Range: "bytes=0-65535" } });
    if (!res.ok) return false;
    const buf = await res.arrayBuffer();
    if (!isGlbBuffer(buf)) return false;

    const full = buf.byteLength >= 65536 ? buf : await (await fetch(url)).arrayBuffer();
    const jsonLen = new DataView(full).getUint32(12, true);
    const json = JSON.parse(
      new TextDecoder().decode(new Uint8Array(full, 20, jsonLen))
    ) as { skins?: unknown[]; nodes?: { name?: string }[] };

    const hasSkin = (json.skins?.length ?? 0) > 0;
    const legBone = json.nodes?.some(n =>
      /leg|thigh|hip|foot|spine/i.test(n.name || "")
    );
    return hasSkin && Boolean(legBone);
  } catch {
    return false;
  }
}

export const probeModelUrl = probeFullBodyGlb;
